export const JWT_ACCESS_TOKEN = 'at';
export const JWT_REFRESH_TOKEN = 'rt';

export const SMALL_SIDEBAR = 'smallSidebar'

export const MIN_PASSWORD_LENGTH = 8;

export const DEFAULT_COLUMN_WIDTH = 150;

export const ZOOM_OPTIONS: Array<number> = [30, 50, 75, 100, 125, 150, 175];

export const DEFAULT_ZOOM = 100;

